export const getWhere = (where, sort, limit, offset) => {
  const params = {
    ...where,
    sort,
    limit,
    offset,
  };

  return {}; // fetchGet(`${Site.api_url}accounts/users?${fetchParams(params)}&accounts=true`);
};

export const save = (data) => {
  return {}; // fetchPost(`${Site.api_url}accounts/users`, data);
};
